import { apiRequest } from "./api";
import type {
  CreateReviewRequest,
  ReviewCandidateResponse,
  ReviewContext,
  ReviewResponse,
  UserRatingsResponse,
} from "../types/reviewTypes";

export const reviewsApi = {
  create(gigRequestId: string, payload: CreateReviewRequest): Promise<ReviewResponse> {
    return apiRequest<ReviewResponse>(`/api/gig-requests/${gigRequestId}/reviews`, {
      method: "POST",
      body: payload,
    });
  },

  listMyCandidates(): Promise<ReviewCandidateResponse[]> {
    return apiRequest<ReviewCandidateResponse[]>("/api/reviews/my/candidates", {
      method: "GET",
    });
  },

  listMySubmitted(): Promise<ReviewResponse[]> {
    return apiRequest<ReviewResponse[]>("/api/reviews/my/submitted", {
      method: "GET",
    });
  },

  getUserRatings(userId: string): Promise<UserRatingsResponse> {
    return apiRequest<UserRatingsResponse>(`/api/users/${userId}/ratings`, {
      method: "GET",
    });
  },

  listUserReviews(userId: string, context?: ReviewContext): Promise<ReviewResponse[]> {
    const path = context
      ? `/api/users/${userId}/reviews?context=${encodeURIComponent(context)}`
      : `/api/users/${userId}/reviews`;

    return apiRequest<ReviewResponse[]>(path, {
      method: "GET",
    });
  },
};
